import { onNavigationDiscard } from './navGeneration.js';
import './magnetDomainDialog.css';

// Hiding changes only the discovery list. Never guess a registrable parent by
// counting labels: "co.uk" and hosted preview suffixes could hide unrelated sites.
export function chooseHiddenDomain(host) {
  return new Promise(resolve => {
    const dialog = document.createElement('dialog'); dialog.className = 'mag-domain-dialog';
    dialog.setAttribute('aria-label', 'Hide website requests');
    const heading = document.createElement('h2'); heading.textContent = 'Hide website requests';
    const message = document.createElement('p'); message.textContent = 'This only hides requests from the review list. It does not allow these websites to load your magnet. You can restore them later.';
    const form = document.createElement('form'); form.method = 'dialog';
    const target = document.createElement('p'); target.textContent = /^\d+(\.\d+){3}$/.test(host) || host.includes(':') ? host : `${host} and its subdomains`;
    form.append(target);
    const actions = document.createElement('div'); actions.className = 'mag-domain-dialog-actions';
    const cancel = document.createElement('button'); cancel.type = 'button'; cancel.textContent = 'Cancel';
    const hide = document.createElement('button'); hide.type = 'submit'; hide.textContent = 'Hide requests';
    actions.append(cancel, hide); form.append(actions); dialog.append(heading, message, form);
    const priorFocus = document.activeElement;
    const off = onNavigationDiscard(() => finish(null));
    let done = false;
    function finish(value) {
      if (done) return; done = true; off(); dialog.remove();
      if (priorFocus?.isConnected) priorFocus.focus(); resolve(value);
    }
    cancel.addEventListener('click', () => finish(null));
    dialog.addEventListener('cancel', event => { event.preventDefault(); finish(null); });
    form.addEventListener('submit', event => { event.preventDefault(); finish(host); });
    document.body.append(dialog); dialog.showModal(); cancel.focus();
  });
}
